import { render, staticRenderFns } from "./iDateField.vue?vue&type=template&id=72973fa8&"
import script from "./iDateField.vue?vue&type=script&lang=js&"
export * from "./iDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports